/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LoginWithJsonWebTokenRequest } from '../../models/login-with-json-web-token-request';
import { LoginWithJsonWebTokenResult } from '../../models/login-with-json-web-token-result';

export interface PostLoginJwt$Params {
  body?: LoginWithJsonWebTokenRequest;
}

export function postLoginJwt(
  http: HttpClient,
  rootUrl: string,
  params?: PostLoginJwt$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<LoginWithJsonWebTokenResult>> {
  const rb = new RequestBuilder(rootUrl, postLoginJwt.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LoginWithJsonWebTokenResult>;
    }),
  );
}

postLoginJwt.PATH = '/Authentication/login/jwt';
